import type * as React from 'react'
import type {TReactSetStateStateParameter} from '~/utils/types'

/** Wraps `this.setState` in a promise that is resolved in `setState`'s callback. */
export const setStatePromise = <State, K extends keyof State, P>(
  this_: React.Component<P, State>,
  setState: TReactSetStateStateParameter<State, K, P>
): Promise<void> => {
  return new Promise(resolve => this_.setState(setState, resolve))
}
